import { render } from "./CartWidget.vue?vue&type=template&id=55b78be5"
import script from "./CartWidget.vue?vue&type=script&lang=js"
export * from "./CartWidget.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/3nb/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/CartWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "55b78be5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('55b78be5', __exports__)) {
    console.log('reload')
    api.reload('55b78be5', __exports__)
  }
  
  module.hot.accept("./CartWidget.vue?vue&type=template&id=55b78be5", () => {
    console.log('re-render')
    api.rerender('55b78be5', render)
  })

}


export default __exports__